module.exports = __webpack_public_path__ + "media/country_flags/bn-d987bd86.png";